import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';

import { routesComputed } from '@/router/index';

@Component({
  components: {},
})
export default class Layout extends Vue {
  private routes: object[] = routesComputed; // 路由
  private defaultActive: string = ''; // 默认选中菜单
  private defaultActiveUpdateTime: number = 0;

  @Watch('$route')
  private routeChange() {
    // clearTimeout(this.defaultActiveUpdateTime);
    // this.defaultActiveUpdateTime = setTimeout(() => {
    //   this.defaultActive = this.$route.matched[1].meta.name;
    // }, 100);
    this.defaultActive = this.$route.matched[1].meta.name;
  }

  private mounted() {
    this.routeChange();
  }
}
